var enableLoanFormRadioButtons, getDataValue;

getDataValue = function() {
  var values;
  if ($('#request-a-loan-form').length) {
    values = $('#request-a-loan-form').find('input.hide');
    return $(values).each(function() {
      var dataValue;
      dataValue = $(this).data('value');
      $(this).val(dataValue);
    });
  }
};

enableLoanFormRadioButtons = function() {
  var $form;
  $form = $(".form--request-a-loan");
  if ($form.length) {
    return $form.each(function() {
      var $radios, $secondApplicant, $secondApplicantFields;
      if ($(this).hasClass('newFormRequest')) {
        $form = $(".sproutForm").find(".form--request-a-loan");
        $radios = $form.find('.applicant-radio').find('input[type="radio"]');
        $secondApplicant = $form.find('.tab:nth-child(3)');
      } else {
        $form = $("#request-a-loan-form");
        $radios = $form.find('.applicant-radio');
        $secondApplicant = $form.find('.second-applicant');
      }
      $secondApplicantFields = $secondApplicant.find('input, select, textarea');
      $secondApplicantFields.each(function() {
        var $this;
        $this = $(this);
        return $this.prop("disabled", true);
      });
      $radios.click(function() {
        var $this;
        $this = $(this);
        if ($this.val() === "One applicant" || $this.val() === "En sökande" || $this.val() === "Yksi hakija" || $this.val() === "OneApplicant") {
          $secondApplicantFields.each(function() {
            $this = $(this);
            return $this.prop("disabled", true);
          });
          $secondApplicant.addClass('hide-for-small-only');
          return $secondApplicant.css('display', 'none');
        } else {
          $secondApplicantFields.each(function() {
            $this = $(this);
            return $this.prop("disabled", false);
          });
          $secondApplicant.removeClass('hide-for-small-only');
          return $secondApplicant.css('display', 'block');
        }
      });
      this.addEventListener('onSproutFormsSubmit', function(event) {
        if ($radios.filter('#fields-applicantRadio-1, #loanAppoinmentApplicationEN_howManyApplicants1, #loanAppoinmentApplicationFI_montakoHakijaa1, #loanAppointmentAppliFISWE_hurMangaSokande1, #loanAppointmentApplicationSWE_hurMangaSokande1, #loanAppointmentAppliAXSWE_hurMangaSokande1').is(':checked')) {
          return $secondApplicantFields.each(function() {
            var $this;
            $this = $(this);
            $this.prop("disabled", false);
            if ($this.attr('type') === "number") {
              return $this.val(0);
            } else if ($this.attr('type') === "email") {
              return $this.val('no-email@mail.com');
            } else if ($this.is(':not(select)')) {
              return $this.val('-');
            }
          });
        }
      }, false);
    });
  }
};

$(function() {
  return enableLoanFormRadioButtons();
});

$(function() {
  return getDataValue();
});

// ---
// generated by coffee-script 1.9.2